import { Tag as AntDTag } from 'antd';
import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';

export const BadgePrimary = styled(AntDTag)`
  padding: 5px;
  font-size: 10px;
  font-weight: 700;
  min-width: 0;
  background-color: ${({ color = colors.primary }) => color};
  border-radius: 0.5rem;
  border-color: ${colors.primary};
  ${({ color = colors.primary }) =>
    color === 'none'
      ? css`
          color: ${colors.primary};
        `
      : css`
          color: ${colors.white};
        `};
  &:hover {
    opacity: 0.8;
  }
`;
